export default {
    namespaced : true,
    state : {
        embedComponents : {},
        sideformEditedNode : null , //node that has been selected to be edited
        sideformPinned : false,
        sideformDisplay : false, //flag to show / hide sideform
        triggerSideformUpdateFlag : false
    },
    getters: {

    },
    actions : {
        
        updateEmbedComponent ( {commit } , payload) {
            commit('updateEmbedComponent', payload);
        },
        setSideformEditedNode ( {commit} , payload) {
            commit('setSideformEditedNode' , payload);
        },
        setSideformDisplay ( {commit} , payload) {
            commit('setSideformDisplay' , payload);
        },
        setSideformUpdateFlag ( {commit} , payload) {
            commit('setSideformUpdateFlag' , payload);
        },
        setSideformPinned ( {commit} , payload) {
            commit('setSideformPinned' , payload);
        }
    },
    mutations : {
        updateEmbedComponent ( state , embedData ) {
            state.embedComponents[embedData.id] = embedData.embedCode;
        },
        setSideformUpdateFlag ( state , flag ) {
            state.triggerSideformUpdateFlag = flag;
        },
        setSideformEditedNode ( state , node ) {
            // console.log("setting edited node " , node)
            state.sideformEditedNode = node;
        },
        setSideformPinned ( state , flag) {
            state.sideformPinned = flag;
        },
        setSideformDisplay ( state , flag ) {
            state.sideformDisplay = flag;
        }
    }
}